import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";

import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import {
  V2,
  navItemSx,
  miniIconSx,
  iconFilterMuted,
  iconFilterAccent,
} from "../drawerV2Tokens";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

// ==============================|| DRAWER COLLAPSE TOGGLE ||============================== //

export default function DrawerCollapseToggle() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const label = drawerOpen ? "Réduire le menu" : "Agrandir le menu";

  const icon = drawerOpen ? (
    <PanelLeftClose size={20} strokeWidth={2} color="currentColor" />
  ) : (
    <PanelLeftOpen size={20} strokeWidth={2} color="currentColor" />
  );

  return (
    <ListItemButton
      onClick={() => handlerDrawerOpen(!drawerOpen)}
      aria-label={label}
      sx={{
        ...navItemSx({ drawerOpen, level: 1, isSelected: false }),
        "&:hover .drawer-collapse-icon-wrap": {
          filter: iconFilterAccent,
        },
      }}
    >
      {drawerOpen ? (
        <ListItemIcon
          className="drawer-collapse-icon-wrap"
          sx={{
            position: "relative",
            minWidth: 38,
            filter: iconFilterMuted,
            color: "#000",
          }}
        >
          {icon}
        </ListItemIcon>
      ) : (
        <Tooltip title={label} placement="right" arrow>
          <ListItemIcon sx={miniIconSx({ isSelected: false })}>
            <Box
              component="span"
              className="drawer-v2-mini-icon"
              sx={{ color: "#000" }}
            >
              {icon}
            </Box>
          </ListItemIcon>
        </Tooltip>
      )}

      {drawerOpen && (
        <ListItemText
          primary={
            <Typography
              variant="h6"
              sx={{
                color: V2.ink,
                fontWeight: 500,
                fontFamily: V2.fontBody,
                fontSize: "0.9rem",
              }}
            >
              Réduire
            </Typography>
          }
        />
      )}
    </ListItemButton>
  );
}
